<template>
	<div class="d-flex flex-column" style="gap: 5px;">
		<!-- <v-menu
			ref="menu"
			v-model="menuOpen"
			transition="scale-transition"
			offset-y
			left
			:close-on-content-click="false"
			nudge-top="-10"
			eager
			v-if="roomAdmin.user_id == userInfo.id && !isClient"
		>
			<template #activator="{ on: onMenu }">
				<v-tooltip bottom>
					<template #activator="{ on: onTooltip }">
						<div v-on="onTooltip">
							<v-btn
								depressed
								color="#524D4D"
								outlined
								x-small
								block
								v-on="onMenu"
							>
								<p class="mb-0 mr-2">Añadir Usuario a Chat</p>
								<v-icon>mdi-account-plus-outline</v-icon>
							</v-btn>
						</div>
					</template>
					<span>Sólo el creador de la sala puede agregar/quitar usuarios</span>
				</v-tooltip>
			</template>
			<v-card scrollable class="pa-0">
				<v-card-text class="pa-0" style="height: 280px; width: 400px; overflow-y: scroll;">
					<v-list dense class="py-0">
						<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
							<div class="d-flex align-center justify-space-between" style="width: 100%;">
								<p class="caption mb-0 font-weight-bold white--text">Agregar Usuarios al Chat Grupal</p>
								<v-chip
									color="green"
									label
									outlined
									x-small
									class="px-1 mr-1"
									style="background-color: white !important;"
								>
									<b>Eres el Administrador</b>
								</v-chip>
							</div>
						</v-list-item>
						<v-list-item-group color="#524D4D">
							<v-list-item
								v-for="(user, index) in userListChat"
								:key="index"
								dense
								:disabled="initialChatUserIds.includes(user.id)" 
								@click="toggleUserToChatList(user.id)"
							>
								<v-list-item-title dense>
									<div class="d-flex align-center">
										<div class="d-flex align-center" style="width: 100%; gap: 5px;">
											<div>
												<img :src="user?.profile?.avatar" class="user-avatar" v-if="user?.profile?.avatar"/>
												<v-icon v-else class="user-avatar icon" color="#524D4D">mdi-account</v-icon>
											</div>
											<div>
												<p class="mb-0 truncate-text">{{ user?.profile?.name }} {{ user?.profile?.lastname }} {{ user?.profile?.second_lastname }}</p>
												<p class="mb-0 text-disabled caption truncate-text">{{ user?.email }}</p>
												<div v-if="initialChatUserIds.includes(user.id)" class="mr-2">
													<p class="mb-0" style="font-size: 10px;">Ya se añadió al chat grupal</p>
												</div>
											</div>
										</div>
										<v-icon v-if="!initialChatUserIds.includes(user.id)" class="mr-2" small :color="icon(user.id).color">{{icon(user.id).icon}}</v-icon>
									</div>
									<v-divider v-if="index != userListChat.length - 1" class="my-1"></v-divider>
								</v-list-item-title>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</v-card-text>
				<v-card-actions class="d-flex justify-end" style="border-top: 1px solid rgba(0,0,0,0.15)">
					<v-btn
						depressed
						color="#524D4D"
						outlined
						dark
						x-small
						class="add-users-chat-btn"
						@click="onAddUserConfirm"
					>
						<v-icon>mdi-account-check-outline</v-icon>
						<p class="mb-0 mr-2">Confirmar</p>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-menu> -->
		<v-menu
			ref="menu2"
			v-model="menuOpen2"
			transition="scale-transition"
			offset-y
			left
			:close-on-content-click="false"
			nudge-top="-10"
			eager
		>
			<template #activator="{ on: onMenu }">
				<v-tooltip bottom>
					<template #activator="{ on: onTooltip }">
						<div v-on="onTooltip">
							<v-btn
								depressed
								color="#524D4D"
								outlined
								x-small
								block
								v-on="onMenu"
							>
								<p class="mb-0 mr-2">Participantes</p>
								<v-icon>mdi-account-group-outline</v-icon>
							</v-btn>
						</div>
					</template>
					<span>Ver participantes de este chat</span>
				</v-tooltip>
			</template>
			<v-card scrollable class="pa-0">
				<v-card-text class="pa-0" style="height: 350px; width: 500px; overflow-y: scroll;">
					<div v-if="showType == 1">
						<div class="d-flex align-center justify-space-between py-2 px-4 grey darken-2 mb-2" style="width: 100%;">
							<p class="caption mb-0 font-weight-bold white--text">Participantes del Grupo</p>
							<v-tooltip bottom>
								<template #activator="{ on: onTooltip }">
									<div v-on="onTooltip">
										<v-btn
											depressed
											color="white"
											outlined
											x-small
											block
											v-on="onTooltip"
											@click="showType = 2"
										>
											<p class="mb-0 mr-2">Añadir Usuario al Grupo</p>
											<v-icon small>mdi-account-plus-outline</v-icon>
										</v-btn>
									</div>
								</template>
								<span>Sólo el creador de la sala puede agregar/quitar usuarios</span>
							</v-tooltip>
						</div>
						<v-list dense class="py-0">
							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(user, index) in filteredChatUsers"
									:key="index"
									dense
								>
									<v-list-item-title dense>
										<div class="d-flex align-center" :style="user.deleted_at ? { pointerEvents: 'none' } : {}">
											<div class="d-flex justify-space-between align-center" style="width: 100%">
												<div class="d-flex align-center" style="width: 100%; gap: 5px;">
													<div :style="user.deleted_at ? { opacity: '0.7', pointerEvents: 'none' } : {}">
														<img :src="user?.user?.profile?.avatar" class="user-avatar" v-if="user?.user?.profile?.avatar"/>
														<v-icon v-else class="user-avatar icon" color="#524D4D">mdi-account</v-icon>
													</div>
													<div>
														<p class="mb-0 truncate-text" :style="user.deleted_at ? { opacity: '0.7', pointerEvents: 'none' } : {}">{{ user?.user?.profile?.name }} {{ user?.user?.profile?.lastname }} {{ user?.user?.profile?.second_lastname }}</p>
														<p class="mb-0 text-disabled caption truncate-text" :style="user.deleted_at ? { opacity: '0.7', pointerEvents: 'none' } : {}">{{ user?.user?.email }}</p>
														<div class="d-flex align-center" style="gap: 5px;">
															<p class="mb-0" style="font-size: 10px;">Agregado: {{ user.created_at | toDateTime }}</p>
														</div>
													</div>
												</div>
												<div class="d-flex align-center" style="gap: 8px;">
													<v-chip
														color="green"
														label
														outlined
														x-small
														v-if="user.user_id == roomAdmin.user_id"
														class="px-1"
													>
														<b>Administrador</b>
													</v-chip>
													<v-chip
														color="green"
														label
														outlined
														x-small
														v-if="isClientOfProject(user)"
														class="px-1"
													>
														<b>Cliente</b>
													</v-chip>
													<v-chip
														color="#FF120B"
														label
														outlined
														small
														v-if="user.deleted_at"
														class="px-1"
														style="height: auto;"
													>
														<div class="d-flex flex-column text-center" style="line-height: 12px;font-size: 11px;gap: 3px;">
															<p class="mb-0 font-weight-bold">Eliminado</p>
															<p class="mb-0">{{ user.deleted_at | toDateTime }}</p>
														</div>
													</v-chip>
													<v-menu
														v-if="user.user_id != roomAdmin.user_id && !isClientOfProject(user) && !isClient && !user.deleted_at"
														offset-y
														transition="scale-transition"
														max-width="300px"
													>
														<template #activator="{ on: onMenu }">
															<v-btn
																icon
																x-small
																color="error"
																v-on="onMenu"
															>
																<v-icon x-small>mdi-trash-can-outline</v-icon>
															</v-btn>
														</template>
														<v-card>
															<v-card-text class="pa-4">
																<p class="mb-0">¿Estás seguro de que deseas eliminar este usuario del grupo?</p>
															</v-card-text>
															<v-card-actions class="d-flex justify-end" style="gap: 8px;">
																<v-btn
																	depressed
																	outlined
																	x-small
																>
																	Cancelar
																</v-btn>
																<v-btn
																	depressed
																	color="error"
																	dark
																	x-small
																	@click="removeUserFromChat(user.user_id)"
																>
																	Eliminar
																</v-btn>
															</v-card-actions>
														</v-card>
													</v-menu>
												</div>
											</div>
										</div>
										<v-divider v-if="index != filteredChatUsers.length - 1" class="my-1"></v-divider>
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</div>
					<div v-else>
						<div class="d-flex align-center justify-space-between py-2 px-4 grey darken-2 mb-2" style="width: 100%;">
							<p class="caption mb-0 font-weight-bold white--text">Agregar Usuarios al Chat Grupal</p>
							<v-tooltip bottom>
								<template #activator="{ on: onTooltip }">
									<div v-on="onTooltip">
										<v-btn
											depressed
											color="white"
											outlined
											x-small
											block
											v-on="onTooltip"
											@click="showType = 1"
										>
											<v-icon small>mdi-arrow-left</v-icon>
											<p class="mb-0 mr-2">Volver</p>
										</v-btn>
									</div>
								</template>
								<span>Volver a los participantes del grupo</span>
							</v-tooltip>
						</div>
						<v-list dense class="py-0">
							<v-list-item-group color="#524D4D">
								<v-list-item
									v-for="(user, index) in userListChat"
									:key="index"
									dense
									:disabled="initialChatUserIds.includes(user.id)" 
									@click="toggleUserToChatList(user.id)"
								>
									<v-list-item-title dense>
										<div class="d-flex align-center">
											<div class="d-flex align-center" style="width: 100%; gap: 5px;">
												<div>
													<img :src="user?.profile?.avatar" class="user-avatar" v-if="user?.profile?.avatar"/>
													<v-icon v-else class="user-avatar icon" color="#524D4D">mdi-account</v-icon>
												</div>
												<div>
													<p class="mb-0 truncate-text">{{ user?.profile?.name }} {{ user?.profile?.lastname }} {{ user?.profile?.second_lastname }}</p>
													<p class="mb-0 text-disabled caption truncate-text">{{ user?.email }}</p>
													<div v-if="initialChatUserIds.includes(user.id)" class="mr-2">
														<p class="mb-0" style="font-size: 10px;">Ya se añadió al chat grupal</p>
													</div>
												</div>
											</div>
											<v-icon v-if="!initialChatUserIds.includes(user.id)" class="mr-2" small :color="icon(user.id).color">{{icon(user.id).icon}}</v-icon>
										</div>
										<v-divider v-if="index != userListChat.length - 1" class="my-1"></v-divider>
									</v-list-item-title>
								</v-list-item>
							</v-list-item-group>
						</v-list>
						<v-divider class="mt-2"></v-divider>
						<div class="py-2 px-4 d-flex justify-end">
							<v-btn
								depressed
								color="#524D4D"
								outlined
								dark
								small
								@click="onAddUserConfirm"
							>
								<v-icon>mdi-account-check-outline</v-icon>
								<p class="mb-0 mr-2">Confirmar</p>
							</v-btn>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
import {createChatRoom, addUserToChatRoom, removeUserFromChatRoom} from '@/helpers/api/chats'
export default {
	name: 'ChatUserManagment',
	props: {
		chatRoom: {
			type: Object,
			required: true
		}
	},
	computed: {
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		userInfo(){
			return this.$store.state.user.userInfo
		},
		userListChat(){
			return this.$store.state.users.usersList.filter((user) => this.userInfo.id != user.id)
		},
		roomAdmin(){
			return this.chatRoom.users.find((user) => user.admin == true)
		},
		filteredChatUsers(){
			// if(this.showType == 1){
			// 	return this.chatRoom.users.filter((user) => user.deleted_at == null)
			// }
			return this.chatRoom.users_history
		}
	},
	watch: {
		chatRoom(newRoom){
			this.initialChatUserIds = newRoom.users.map(user => user.user_id)
			this.add_chat_users_id = newRoom.users.map(user => user.user_id)
		},
		menuOpen2(newValue){
			if(!newValue){
				// Resetear estado cuando se cierra el menú
				this.showType = 1
				this.add_chat_users_id = this.chatRoom.users.map(user => user.user_id)
			}
		}
	},
	data() {
		return {
			add_chat_users_id: [],
			initialChatUserIds: [],
			menuOpen: false,
			menuOpen2: false,
			showType: 1
		};
	},
	mounted() {
		this.initialChatUserIds = this.chatRoom.users.map(user => user.user_id)
		this.add_chat_users_id = this.chatRoom.users.map(user => user.user_id)
	},
	methods: {
		isClientOfProject(user){
			if(!this.chatRoom.morphable?.associations) return false
			return this.chatRoom.morphable.associations.some(association => {
				const morphable = association.morphable
				if(!morphable) return false
				if(association.morphable_type === 'App\\Models\\BotConversation'){
					return morphable.client?.id === user.user_id
				}
				if(association.morphable_type === 'App\\Models\\PreProject' || association.morphable_type === 'App\\Models\\Project'){
					return morphable.client_id === user.user_id
				}
				
				return false
			})
		},
		icon(user_id){
			const find = this.add_chat_users_id.find((userid) => user_id == userid)
			if(find){
				return {icon: 'mdi-checkbox-intermediate', color: '#FF120B'}
			}
			return {icon: 'mdi-checkbox-blank-outline', color: '#524D4D'}
		},
		toggleUserToChatList(user_id){
			if (this.add_chat_users_id.includes(user_id)) {
				this.add_chat_users_id = this.add_chat_users_id.filter(id => id !== user_id);
			} else {
				this.add_chat_users_id = [...this.add_chat_users_id, user_id];
			}
		},
		async onAddUserConfirm(){
			try {
				await addUserToChatRoom({
					chat_room_id: this.chatRoom.id,
					users_id: this.add_chat_users_id,
				})
				this.showType = 1
				const messageData = {
					message: 'Usuarios guardados correctamente',
					title: 'Usuarios guardados',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
				this.$emit('reload')
			} catch (error) {
				const messageData = {
					message: 'Ha ocurrido un error, por favor intenta nuevamente',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async removeUserFromChat(userId){
			try {
				await removeUserFromChatRoom({
					chat_room_id: this.chatRoom.id,
					users_id: [userId],
				})
				const messageData = {
					message: 'Usuario eliminado correctamente',
					title: 'Usuario eliminado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
				this.$emit('reload')
			} catch (error) {
				const messageData = {
					message: 'Ha ocurrido un error al eliminar el usuario',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async createPreProjectChatRoom(){
			this.loadingChatCreation = true
			const data = {
				name: this.preproject.name,
				type: "App\\Models\\PreProject",
				type_id: this.preproject.id,
				users_id: [this.preproject.client_id]
			}
			await createChatRoom(data)
			this.$store.dispatch('preprojects/getPreProject', {preproject_id: this.preproject.id})
			this.loadingChatCreation = false
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	}
}
</script>

<style>
.truncate-text {
  max-width: 230px; /* Ajusta según lo que necesites */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style scoped>
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
</style>